<div class="tCol clickCol" id="MFAEnabled_{{ item.id }}">
  @if (item.mfaEnabled) {
    <span>Yes</span>
  }
  @if (!item.mfaEnabled) {
    <span>No</span>
  }
</div>
